var map = {
	".": 3271,
	"./": 3271,
	"./development": 9757,
	"./development/": 9757,
	"./development/index": 9757,
	"./development/index.js": 9757,
	"./index": 3271,
	"./index.js": 3271,
	"./production": 9227,
	"./production/": 9227,
	"./production/index": 9227,
	"./production/index.js": 9227,
	"./uat": 4794,
	"./uat/": 4794,
	"./uat/index": 4794,
	"./uat/index.js": 4794
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8418;